import { render, staticRenderFns } from "./SearchForAsset.vue?vue&type=template&id=cfcbf6a6&lang=pug&"
import script from "./SearchForAsset.vue?vue&type=script&lang=js&"
export * from "./SearchForAsset.vue?vue&type=script&lang=js&"
import style0 from "./SearchForAsset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports